import { LabelValueOptionModel } from '@/domain/models/onboarding/label-value-option-model'

export interface OnboardingOptions {
  getStep1(): Promise<OnboardingOptions.Step1Model>
  getStep3(): Promise<OnboardingOptions.Step3Model>
  getStep4(): Promise<OnboardingOptions.Step4Model>
}

export namespace OnboardingOptions {
  export type Step1Model = {
    maritalStatus: LabelValueOptionModel<number>[]
    professionalAreas: LabelValueOptionModel<number>[]
    professionalSeniorities: LabelValueOptionModel<number>[]
  }
  export type Step3Model = { interestAreas: LabelValueOptionModel<number>[] }

  export type Step4Model = {
    skillOptions: LabelValueOptionModel<number>[]
    skillOptionsSuggestion: LabelValueOptionModel<number>[]
  }

  export type Step4WithRecommendationsModel = Step4Model & {
    skillsRecommendedByAreas: LabelValueOptionModel<number>[]
  }

  export const KeyGetStep1 = 'onboarding-options-step-1'
  export const KeyGetStep3 = 'onboarding-options-step-3'
  export const KeyGetStep4 = 'onboarding-options-step-4'
}
